import type { IHistoryEntry, ILink, IRecord } from '@platform/core/types';

/**
 * Експорт запису в JSON (прототип v4, fExport): код, модуль, тип, назва, статус, значення полів, теги, зв'язки (тип, код, назва) та
 * історія — як у файлі «<код>.json» прототипу. Користувачі в значеннях — іменами. Чиста функція.
 */
export function recordJson(record: IRecord, moduleName: string, links: ILink[], history: IHistoryEntry[]): string {
  const values = Object.fromEntries(Object.entries(record.values).map(([k, v]) => [k, v && typeof v === 'object' && 'name' in v ? (v as { name: string }).name : v ?? null]));
  return JSON.stringify({
    code: record.display, module: moduleName, recordType: record.recordType, title: record.title, status: record.status, values, tags: record.tags,
    related: links.map((l) => ({ type: l.linkType, code: l.otherDisplay, title: l.otherTitle, module: l.otherModule })),
    history: history.map((h) => ({ at: h.at, who: h.actor?.name ?? null, kind: h.kind, field: h.fieldLabel ?? h.field ?? null, from: h.from ?? null, to: h.to ?? null })),
    createdAt: record.createdAt, updatedAt: record.updatedAt,
  }, null, 2);
}
